// Remove any currency symbols or commas, then convert to a number
export default function extractPrice(priceStr: string) {
  return parseFloat(priceStr.replace(/[$,]/g, ""));
}
